import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

export default function PlanesPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const fleet = [
    { name: 'Learjet 45', category: 'Midsize Jet', capacity: '7-9 Passengers', range: '2,040 nm', speed: '465 kts', rate: '$3,600/hr', image: 'https://storage.readdy-site.link/project_files/a8799dc5-05d6-47d3-b91a-22752c6df7a4/7dded3c0-f67e-446f-8503-65f6865a347f_Priester-Learjet.webp?v=8b180ddf6d8eb147c8b91355ce4e6bc3', objectPosition: 'object-left', features: ['Stand-up cabin', 'Club seating', 'Refreshment center', 'WiFi'] },
    { name: 'Citation XLS+', category: 'Midsize Jet', capacity: '8-9 Passengers', range: '2,100 nm', speed: '441 kts', rate: '$4,200/hr', image: 'https://static.readdy.ai/image/b0020c9f1a780c0942b742aa130ad404/dfdbc602e3ea9f3a5fccea012c031399.jpeg', objectPosition: 'object-left', features: ['Stand-up cabin', 'Club seating', 'Refreshment center', 'WiFi'] },
    { name: 'Cessna Citation X', category: 'Super Midsize', capacity: '8-12 Passengers', range: '3,460 nm', speed: '527 kts', rate: '$6,800/hr', image: 'https://public.readdy.ai/ai/img_res/7638778a125d01ecc2162d98410ffe55.jpg', features: ['High-speed cruise', 'Spacious cabin', 'Refreshment center', 'WiFi'] },
    { name: 'Embraer Phenom 300', category: 'Light Jet', capacity: '6-9 Passengers', range: '2,010 nm', speed: '453 kts', rate: '$3,200/hr', image: 'https://readdy.ai/api/search-image?query=Modern%20Embraer%20Phenom%20300%20light%20business%20jet%20exterior%20showcasing%20compact%20white%20fuselage%20with%20gold%20accent%20details%20and%20efficient%20wing%20design%20against%20a%20soft%20gradient%20background%20from%20pale%20ivory%20to%20light%20champagne%20emphasizing%20versatile%20regional%20travel%20capability%20and%20contemporary%20aviation%20styling&width=600&height=800&seq=fleet-phenom300-001&orientation=portrait', features: ['Efficient performance', 'Comfortable seating', 'Baggage capacity', 'Modern avionics'] },
    { name: 'Dassault Falcon 8X', category: 'Ultra Long Range', capacity: '12-16 Passengers', range: '6,450 nm', speed: '488 kts', rate: '$9,500/hr', image: 'https://readdy.ai/api/search-image?query=Elegant%20Dassault%20Falcon%208X%20trijet%20private%20aircraft%20exterior%20photograph%20featuring%20distinctive%20white%20fuselage%20with%20gold%20metallic%20striping%20and%20three%20rear-mounted%20engines%20against%20a%20refined%20gradient%20background%20from%20soft%20pearl%20to%20light%20beige%20showcasing%20French%20aviation%20engineering%20excellence%20and%20intercontinental%20range%20capability&width=600&height=800&seq=fleet-falcon8x-001&orientation=portrait', features: ['Three-engine safety', 'Spacious cabin', 'Advanced technology', 'Quiet operation'] },
    { name: 'Learjet 75 Liberty', category: 'Light Jet', capacity: '6-8 Passengers', range: '2,080 nm', speed: '465 kts', rate: '$3,500/hr', image: 'https://readdy.ai/api/search-image?query=Sporty%20Learjet%2075%20Liberty%20light%20business%20jet%20exterior%20showcasing%20sleek%20white%20aircraft%20body%20with%20gold%20accent%20stripes%20and%20distinctive%20swept%20wings%20against%20a%20minimal%20gradient%20background%20from%20soft%20cream%20to%20pale%20champagne%20highlighting%20agile%20performance%20and%20efficient%20regional%20business%20aviation&width=600&height=800&seq=fleet-learjet75-001&orientation=portrait', features: ['Quick turnaround', 'Executive seating', 'Baggage access', 'Modern cockpit'] },
    { name: 'Citation Encore+', category: 'Midsize Jet', capacity: '7-9 Passengers', range: '1,776 nm', speed: '429 kts', rate: '$3,800/hr', image: 'https://storage.readdy-site.link/project_files/a8799dc5-05d6-47d3-b91a-22752c6df7a4/9034b98b-ad0b-416d-8a15-3ba48b694558_WisconsinAviationEncore.jpg?v=debacddebd37ebc5c4523db06b3eb1d9', features: ['Stand-up cabin', 'Refreshment center', 'WiFi', 'Aft lavatory'] },
    { name: 'Pilatus PC-12', category: 'Turboprop', capacity: '6-9 Passengers', range: '1,845 nm', speed: '270 kts', rate: '$2,200/hr', image: 'https://storage.readdy-site.link/project_files/a8799dc5-05d6-47d3-b91a-22752c6df7a4/2eb58b76-a6c5-4e7c-b50e-d3ab15d349f2_Pilatus-PC-12.webp?v=3b2a439c0ade64c44244260893259410', objectPosition: 'object-center', features: ['Short runway capable', 'Large cargo door', 'Flexible cabin', 'All-weather'] },
    { name: 'Citation CJ1', category: 'Light Jet', capacity: '5-6 Passengers', range: '1,297 nm', speed: '389 kts', rate: '$2,400/hr', image: 'https://storage.readdy-site.link/project_files/a8799dc5-05d6-47d3-b91a-22752c6df7a4/b9b98316-9370-4639-baa8-54564e93d980_Wisconsin-Aviation-CJ1.jpg?v=8360fa8aff39ab1a0ff70d0420da5c59', objectPosition: 'object-left', mobileSmall: true, features: ['Efficient performance', 'Club seating', 'Baggage access', 'Short runway capable'] },
  ];

  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${siteUrl}/planes`,
      name: 'Private Jet Fleet | YESJETS Aircraft – Gulfstream, Bombardier & More',
      url: `${siteUrl}/planes`,
      description: 'Browse the YESJETS luxury private jet fleet: Gulfstream G650, Bombardier Global 7500, Citation X, Dassault Falcon 8X, Citation Encore+, and more. Charter from $3,000/hr.',
      isPartOf: { '@type': 'WebSite', '@id': `${siteUrl}/#website` },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
          { '@type': 'ListItem', position: 2, name: 'Our Fleet', item: `${siteUrl}/planes` },
        ],
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      '@id': `${siteUrl}/planes#fleet`,
      name: 'YESJETS Private Jet Fleet',
      description: 'Explore the full YESJETS fleet of luxury private jets including ultra-long-range, midsize, and light jets available for charter worldwide.',
      numberOfItems: fleet.length,
      itemListElement: fleet.map((aircraft, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          name: aircraft.name,
          description: `${aircraft.category} private jet. Capacity: ${aircraft.capacity}. Range: ${aircraft.range}. Speed: ${aircraft.speed}.`,
          offers: {
            '@type': 'Offer',
            price: aircraft.rate.replace(/[^0-9]/g, ''),
            priceCurrency: 'USD',
            priceSpecification: {
              '@type': 'UnitPriceSpecification',
              price: aircraft.rate.replace(/[^0-9]/g, ''),
              priceCurrency: 'USD',
              unitText: 'hour',
            },
            availability: 'https://schema.org/InStock',
            seller: { '@type': 'Organization', name: 'YESJETS', url: siteUrl },
          },
        },
      })),
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Private Jet Fleet | YESJETS Aircraft – Gulfstream, Bombardier & More"
        description="Browse the YESJETS luxury private jet fleet: Gulfstream G650, Bombardier Global 7500, Citation X, Dassault Falcon 8X, Citation Encore+, and more. Charter from $3,000/hr."
        keywords="private jet fleet, Gulfstream G650 charter, Bombardier Global 7500, Citation X rental, luxury aircraft YESJETS"
        canonical="/planes"
        jsonLd={jsonLd}
      />

      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[45vh] md:h-[60vh] w-full overflow-hidden mt-16 md:mt-20">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Single%20sleek%20white%20luxury%20private%20jet%20taxiing%20on%20a%20wide%20open%20airport%20tarmac%20at%20golden%20hour%20with%20warm%20amber%20and%20deep%20blue%20sky%20gradient%20in%20the%20background%2C%20dramatic%20low%20angle%20perspective%20showing%20the%20full%20length%20of%20the%20aircraft%2C%20ultra%20clean%20minimalist%20composition%2C%20cinematic%20lighting%2C%20premium%20private%20aviation%20atmosphere%2C%20no%20people%2C%20photorealistic&width=1920&height=800&seq=fleet-hero-009&orientation=landscape"
            alt="Fleet"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>

        <div className="relative h-full flex items-center justify-center px-6 md:px-8">
          <div className="text-center text-white">
            <h1 className="text-4xl sm:text-5xl md:text-7xl font-serif font-semibold mb-3 md:mb-4">
              THE EXCLUSIVE FLEET
            </h1>
            <p className="text-base md:text-xl font-sans text-gray-200 max-w-2xl mx-auto">
              Choose from our collection of world-class aircraft, each maintained to the highest standards
            </p>
          </div>
        </div>
      </section>

      {/* Fleet Grid */}
      <section className="py-16 md:py-24 bg-[#f8f7f5]">
        <div className="max-w-7xl mx-auto px-6 md:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10">
            {fleet.map((aircraft, index) => (
              <div key={index} className="group relative rounded-3xl overflow-hidden cursor-pointer transition-transform hover:scale-[1.03] hover:shadow-2xl bg-white">
                <div className={`w-full ${aircraft.mobileSmall ? 'aspect-[4/3] sm:aspect-[3/4]' : 'aspect-[3/4]'}`}>
                  <img src={aircraft.image} alt={aircraft.name} className={`w-full h-full object-cover ${aircraft.objectPosition ?? 'object-right'}`} />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6 text-white">
                  <div className="text-xs font-sans text-gold uppercase tracking-wider mb-2">{aircraft.category}</div>
                  <h3 className="text-xl md:text-2xl font-serif font-semibold mb-2">{aircraft.name}</h3>
                  <div className="text-sm font-sans text-gray-300 mb-3 space-y-1">
                    <p>{aircraft.capacity}</p>
                    <p>Range: {aircraft.range} • Speed: {aircraft.speed}</p>
                  </div>
                  <div className="flex flex-wrap gap-2 mb-3 md:mb-4">
                    {aircraft.features.map((feature, idx) => (
                      <span key={idx} className="text-xs bg-white/20 px-3 py-1 rounded-full">{feature}</span>
                    ))}
                  </div>
                  <div className="flex items-center gap-2 text-sm font-sans">
                    <span>VIEW DETAILS</span>
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-20 bg-navy">
        <div className="max-w-4xl mx-auto px-6 md:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-white mb-5 md:mb-6">
            Can't Find What You're Looking For?
          </h2>
          <p className="text-base md:text-lg text-gray-400 font-sans mb-6 md:mb-8">
            Our team can source a vast number of aircraft to meet your specific requirements
          </p>
          <a href="/contact" className="inline-flex items-center gap-3 bg-gold text-black px-8 md:px-10 py-3 md:py-4 rounded-full text-sm md:text-base font-sans font-semibold tracking-wide hover:bg-gold/90 transition-all cursor-pointer whitespace-nowrap">
            CONTACT US
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
